import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Manual Routes and Pages
 */
const ListSoftwarePage = React.lazy(() => import("./ListSoftwarePage"));
const AddSoftwarePage = React.lazy(() => import("./AddSoftwarePage"));
const EditSoftwarePage = React.lazy(() => import("./EditSoftwarePage"));

const SoftwareRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListSoftwarePage />} />
      <Route exact path="/add" element={<AddSoftwarePage />} />
      <Route exact path="/edit/:id" element={<EditSoftwarePage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default SoftwareRoutes;
